import { useTheme } from "@mui/material";
import { createSxStyles } from "../../common/createSxStyles";

export const useProcessingActivityOverviewStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        container: {
            width: "100%",
            height: "100%",
        },
        tableContainer: {
            flex: "1",
            display: "flex",
            flexDirection: "column",
            marginTop: theme.spacing(2),
        },
        percentageContainer: {
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            width: "100%",
            paddingLeft: 2,
            paddingRight: 2,
        },
        securityMeasure: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "& svg": {
                height: 20,
                marginRight: theme.spacing(0.5),
            },
        },
        percentageSkeleton: {
            marginTop: theme.spacing(0.5),
        },
        gridContentAlignment: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(2),
        },
        riskAssessmentText: {
            color: theme.palette.primary.dark,
            fontSize: theme.typography.pxToRem(12),
            height: "55px",
            display: "flex",
            justifyContent: "center",
            boxOrient: "vertical",
            overflow: "hidden",
        },
        textAlignLeft: {
            textAlign: "left",
        },
        ownerBlock: {
            display: "flex",
            justifyContent: "center",
            "& svg": {
                fill: theme.palette.error.light,
                marginLeft: theme.spacing(0.5),
                height: 17,
                width: 17,
            },
        },
        validationContainer: {
            fontSize: 10,
            color: theme.palette.primary.dark,
            alignSelf: "flex-end",
            textAlign: "left",
        },
    });
};
